/**
 * Mapa de caracteres de racha de API (inglés) a visualización (español).
 * w = win → V (victoria), l = loss → D (derrota), d = draw → E (empate)
 *
 * @type {Object<string, { label: string, color: string, bgClass: string }>}
 */
export const RACHA_MAP = {
    w: { label: "V", color: "success", bgClass: "tw:bg-green-500" },
    v: { label: "V", color: "success", bgClass: "tw:bg-green-500" },
    l: { label: "D", color: "danger", bgClass: "tw:bg-red-500" },
    d: { label: "E", color: "warning", bgClass: "tw:bg-gray-400" },
    e: { label: "E", color: "warning", bgClass: "tw:bg-gray-400" },
};
